import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import axios from "axios";
import { Row, Col } from "react-bootstrap";

import { Api } from "../../../utils/Variables";
import { ServiceUrl } from "../../../utils/ServiceUrl";

const CategoriesMenu = ({ location, history }) => {
  const [categories, setCategories] = useState([]);
  const [showMenu, setShowMenu] = useState(true);

  // useEffect(() => {
  //   axios.get(`${Api.Url}${ServiceUrl.MENU.MEGA_MENU}`).then((res) => {
  //     if (res.data.status === "1") {
  //       setCategories(res.data.data);
  //     }
  //   });
  // }, []);

  useEffect(() => {
    axios.get(`${Api.Url}${ServiceUrl.MENU.MEGA_MENU}`).then((res) => {
      if (res.data.status === "1") {
        const filtered = res.data.data.filter(
          (cat) =>
            cat.categoryname.toLowerCase() !== "saree" &&
            cat.categoryname.toLowerCase() !== "lehenga"
        );
        setCategories(filtered);
      }
    });
  }, []);

  useEffect(() => {
    setShowMenu(true);
  }, [location.pathname]);

  const handleLinkClick = (slug) => {
    setShowMenu(false);

    const targetPath = `/category/${slug}`;
    if (location.pathname === targetPath) {
      history.replace("/");
      setTimeout(() => {
        history.push(targetPath);
      }, 0);
    } else {
      history.push(targetPath);
    }
  };

  const mainCategories = () => {
    return categories.map((item, i) => (
      <Col key={i}>
        <div className="list-group list-group-flush list-group-no-border list-group-sm">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleLinkClick(item.slug);
            }}
            className="list-group-item list-group-item-action text-muted"
          >
            <strong>{item.categoryname.toUpperCase()}</strong>
          </a>
          {item.subcategory && item.subcategory.length > 0 ? (
            <div className="subcategories text-dark">
              {singleCategory(item.subcategory)}
            </div>
          ) : (
            <div className="no-subcategories"></div>
          )}
        </div>
      </Col>
    ));
  };

  const singleCategory = (items) => {
    return items.map((item, i) => (
      <a
        key={i}
        href="#"
        onClick={(e) => {
          e.preventDefault();
          handleLinkClick(item.slug);
        }}
        className="list-group-item list-group-item-action text-muted"
      >
        {item.categoryname}
      </a>
    ));
  };

  return showMenu ? (
    <div
      className="dropdown-menu"
      aria-labelledby="megaDropdown"
      style={{ width: "600px", left: "-200px", backgroundColor: "#fff" }}
    >
      <Row>{mainCategories()}</Row>
    </div>
  ) : null;
};

export default withRouter(CategoriesMenu);
